export const REFS = {
  THEME_SELECTOR: "theme-selector",
  THEME_SELECTOR_LOCK_IN: "theme-selector-lock-in",
  FACESWAP: "faceswap",
  CREDITS: "credits",
  THEME_TITLE: "theme-title",
  OUTFIT_ITEM: "outfit-item",
};
